<template>
  <div>
    <div
      v-if="isUserItemsView"
      class="flex items-center relative overflow-hidden mb-4"
      :class="
        reviewAssignmentUsers.length === 0 && !assignmentLoading
          ? ''
          : 'users-container p-4'
      "
    >
      <h4
        class="mr-2 w-26"
        v-if="!assignmentLoading && reviewAssignmentUsers.length > 0"
      >
        To Review
      </h4>
      <!-- <vx-tooltip
        v-if="!assignmentLoading && reviewAssignmentUsers.length > 0"
        class="capitalize"
        text="Previous"
      >
        <div
          class="arrow previous m-1 mb-2"
          @click="handlePrevious"
          :class="
            currentSelectedUserIndex > 0 ? '' : 'pointer-event-none opacity-50'
          "
        >
          &lt;
        </div>
      </vx-tooltip> -->

      <div v-if="assignmentLoading && reviewAssignmentUsers.length === 0">
        <vs-avatar v-for="i in 6" :key="i" size="40px" class="animate-pulse" />
      </div>
      <div
        class="flex items-center w-1"
        v-if="reviewAssignmentUsers && reviewAssignmentUsers.length > 0"
      >
        <div
          v-for="(user, index) in reviewAssignmentUsers"
          :key="index"
          @click="setActiveCircle(index)"
          v-show="user && user.userData"
        >
          <vx-tooltip
            class="capitalize"
            :text="`${user.userData.firstName} ${user.userData.lastName}`"
          >
            <vs-avatar
              @click.native="setActiveCircle(index)"
              :class="{ active: index === currentSelectedUserIndex }"
              :style="
                borderStyle(
                  user.feedLibraryItemStatus,
                  user.feedItemUserValidationStatus
                )
              "
              :size="index === currentSelectedUserIndex ? '47px' : '40px'"
              class="m-1 w-100 z-10"
              v-if="user.userData.profilePictureUrl"
              :src="`${constants.s3Bucket}/editor/profile-pictures/${user.userData.profilePictureUrl}`"
            />

            <vs-avatar
              @click.native="setActiveCircle(index)"
              :class="{ active: index === currentSelectedUserIndex }"
              :style="
                borderStyle(
                  user.feedLibraryItemStatus,
                  user.feedItemUserValidationStatus
                )
              "
              v-else
              :size="index === currentSelectedUserIndex ? '47px' : '40px'"
              class="m-1"
              :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                user.userData.firstName || 'boringAvatar',
                user.userData.lastName || 'boringAvatar'
              )}`"
            />
          </vx-tooltip>
        </div>
      </div>

      <div class="absolute h-100 next-2 z-10 p-2 pl-0">
        <vx-tooltip class="capitalize" text="Next">
          <img
            v-if="
              reviewAssignment &&
              reviewAssignment.users &&
              reviewAssignment.users.length
            "
            class="arrow next right-4 m-1 mb-2"
            @click="handleNext"
            :class="
              currentSelectedUserIndex < reviewAssignment.users.length - 1
                ? ''
                : 'pointer-event-none opacity-50'
            "
            src="@/assets/images/icons/next-arrow.svg"
            alt=""
          />
        </vx-tooltip>
      </div>
    </div>

    <!-- current active user  -->
    <div
      class="admin__container overflow-hidden"
      v-if="
        reviewAssignment.users &&
        reviewAssignment.users[currentSelectedUserIndex] &&
        reviewAssignment.users[currentSelectedUserIndex].userData
      "
    >
      <div
        class="relative admin__container__main shadow rounded-lg mb-50 md:mb-2"
      >
        <div class="details__container">
          <div class="details__picture">
            <img
              v-if="
                reviewAssignment.users[currentSelectedUserIndex] &&
                reviewAssignment.users[currentSelectedUserIndex].userData
                  .profilePictureUrl
              "
              class="rounded-circle __img"
              :style="
                borderStyle(
                  reviewAssignment.users[currentSelectedUserIndex]
                    .feedLibraryItemStatus,
                  reviewAssignment.users[currentSelectedUserIndex]
                    .feedItemUserValidationStatus
                )
              "
              :src="`${constants.s3Bucket}/editor/profile-pictures/${reviewAssignment.users[currentSelectedUserIndex].userData.profilePictureUrl}`"
              alt="Profile Picture"
            />

            <img
              v-else
              class="rounded-circle __img"
              :style="
                borderStyle(
                  reviewAssignment.users[currentSelectedUserIndex]
                    .feedLibraryItemStatus,
                  reviewAssignment.users[currentSelectedUserIndex]
                    .feedItemUserValidationStatus
                )
              "
              :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                reviewAssignment.users[currentSelectedUserIndex].userData
                  .firstName || 'boringAvatar',
                reviewAssignment.users[currentSelectedUserIndex].userData
                  .lastName || 'boringAvatar'
              )}`"
              alt="Profile Picture"
            />

            <!-- <span
              class="__role __role__do"
              v-if="
                reviewAssignment.users[currentSelectedUserIndex]
                  .feedLibraryItemStatus === 'do'
              "
              >Assigned</span
            >
            <span
              class="__role __role__doing"
              v-else-if="
                reviewAssignment.users[currentSelectedUserIndex]
                  .feedLibraryItemStatus === 'doing'
              "
              >In Progress</span
            > -->

            <span
              class="__role __role__do"
              v-if="
                reviewAssignment.users[currentSelectedUserIndex]
                  .feedLibraryItemStatus === 'notInterested'
              "
              >Not Interested</span
            >
            <span
              class="__role __role__do"
              v-if="
                reviewAssignment.users[currentSelectedUserIndex]
                  .feedLibraryItemStatus === 'do'
              "
              >Not Started</span
            >
            <span
              class="__role __role__doing"
              v-if="
                reviewAssignment.users[currentSelectedUserIndex]
                  .feedLibraryItemStatus === 'doing'
              "
              >In progress</span
            >
            <span
              class="__role __role__doing"
              v-if="
                reviewAssignment.users[currentSelectedUserIndex]
                  .feedLibraryItemStatus === 'done' && !isUserValidated
              "
              >Awaiting Validation</span
            >

            <span
              class="__role"
              v-if="
                isUserValidated &&
                reviewAssignment.users[currentSelectedUserIndex]
                  .feedLibraryItemStatus === 'done'
              "
              >To Review</span
            >
          </div>

          <div class="details__information">
            <div class="main__info">
              <h3>
                {{
                  reviewAssignment.users[currentSelectedUserIndex].userData
                    .firstName
                }}
                {{
                  reviewAssignment.users[currentSelectedUserIndex].userData
                    .lastName
                }}
              </h3>
              <h6>
                {{
                  reviewAssignment.users[currentSelectedUserIndex].userData
                    .profession
                }}
              </h6>
            </div>

            <!-- <div class="skills__info">
              <h6>Skill</h6>

              <div>
                <span>Figma</span>
                <span>Adobe Illustrator </span>
                <span>Office 365</span>
              </div>
            </div> -->

            <div class="contact__info">
              <div class="contact__details">
                <img
                  src="@/assets/images/icons/org-review/iconEmail.svg"
                  alt="email"
                />

                <div>
                  {{
                    reviewAssignment.users[currentSelectedUserIndex].userData
                      .email
                  }}
                </div>
              </div>

              <!-- <div class="contact__details">
                <img
                  :src="
                    require(`@/assets/images/icons/org-review/iconPhone.svg`)
                  "
                  alt="phone"
                />

                <a>+12 345 6789 0</a>
              </div> -->
            </div>
          </div>
        </div>

        <div class="treasury__container">
          <h3>Wallet</h3>
          <h4>
            {{ xp }}
            XP
          </h4>
          <div class="treasury__information">
            <div class="treasury__information__1">
              <!-- <h6>Pending Validation</h6>
              <h5>40 XP</h5> -->
            </div>

            <div class="treasury__information__2">
              <!-- <h6>Successful Distributions</h6>
              <h5>6000 XP</h5> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- item to review  -->
    <!-- Skeleton  -->
    <div v-if="assignmentLoading">
      <div
        v-for="i in 2"
        :key="i"
        class="border border-blue-300 shadow rounded-lg p-4 w-full animate-pulse h-48 my-6"
        style="background: #8080805e"
      ></div>
    </div>
    <vx-card
      v-if="
        reviewAssignment &&
        reviewAssignment.feedLibraryItem &&
        !assignmentLoading &&
        reviewAssignmentUsers.length > 0
      "
      class="my-4"
    >
      <vs-row class="flex-col md:flex-row"
        ><vs-col class="md:w-1/3 lg:w-1/6">
          <div class="overflow-hidden rounded-lg assignment__img">
            <img
              class="h-full w-full object-cover"
              :src="
                reviewAssignment.feedLibraryItem.imageUrl
                  ? reviewAssignment.feedLibraryItem.imageUrl
                  : randomFeedImage
              "
              :alt="reviewAssignment.feedLibraryItem.title"
              @error="randomFeedImage"
            /></div></vs-col
        ><vs-col
          class="md:w-2/3 lg:w-5/6 md:pl-8 flex flex-col justify-between"
        >
          <div>
            <div
              class="flex items-center mt-2 lg:mt-0"
              v-if="
                reviewAssignment.users &&
                reviewAssignment.users[0].assignedFromGtbrddUserId
              "
            >
              <div class="h-8 w-8 overflow-none mr-2" v-if="userName !== 'you'">
                <img
                  class="w-full h-full object-cover rounded-full"
                  :src="
                    userProfilePic
                      ? constants.s3Bucket +
                        '/editor/profile-pictures/' +
                        userProfilePic
                      : `https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                          userName,
                          userName
                        )}`
                  "
                />
              </div>
              <div class="font-semibold text-lg text-black">
                Assigned By {{ userName }}
                {{
                  getAssignedUser(
                    reviewAssignment.users[0].assignedFromGtbrddUserId
                  )
                }}
              </div>
            </div>
            <div
              class="flex items-center mt-2 lg:mt-0"
              v-else-if="
                reviewAssignment.feedLibraryItem.assignedBy.type === 'user'
              "
            >
              <div class="h-8 w-8 overflow-none mr-2" v-if="userName !== 'you'">
                <img
                  class="w-full h-full object-cover rounded-full"
                  :src="
                    userProfilePic
                      ? constants.s3Bucket +
                        '/editor/profile-pictures/' +
                        userProfilePic
                      : `https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                          userName,
                          userName
                        )}`
                  "
                />
              </div>
              <div class="font-semibold text-lg text-black">
                Assigned By {{ userName }}
                {{
                  getAssignedUser(
                    reviewAssignment.feedLibraryItem.assignedBy._id
                  )
                }}
              </div>
            </div>
            <div v-else></div>

            <div class="flex items-center">
              <div
                class="text-black text-2xl truncate grow mt-2 lg:mt-0"
                v-if="
                  reviewAssignment.feedLibraryItem &&
                  reviewAssignment.feedLibraryItem.title
                "
              >
                {{ reviewAssignment.feedLibraryItem.title }}
              </div>

              <img
                @click.once="openLink(reviewAssignment.feedLibraryItem)"
                class="ml-3 mt-2 lg:mt-0 cursor-pointer"
                src="@/assets/images/icons/arrow-right-circle.svg"
                alt="right-arrow"
              />
            </div>

            <div
              class="text-lg gray-400 my-3"
              v-if="
                reviewAssignment.feedLibraryItem &&
                reviewAssignment.feedLibraryItem.description &&
                typeof reviewAssignment.feedLibraryItem.description === 'string'
              "
            >
              {{ reviewAssignment.feedLibraryItem.description }}
            </div>

            <div
              class="text-lg gray-400 my-3"
              v-else-if="
                reviewAssignment.feedLibraryItem.description.length > 0
              "
            >
              <div
                v-for="(data, index) in reviewAssignment.feedLibraryItem
                  .description"
                :key="index"
                v-html="data"
              ></div>
            </div>
          </div>
          <!-- 
          <div
            v-if="
              reviewAssignment.users &&
              reviewAssignment.users[currentSelectedUserIndex] &&
              reviewAssignment.users[currentSelectedUserIndex]
                .feedLibraryItemStatus === 'done' &&
              reviewAssignment.libraryItemValidationData &&
              reviewAssignment.libraryItemValidationData.validationType ===
                'upload'
            "
            class="flex items-center justify-end"
          >
            <div
              class="button__decline px-3 py-2 mr-3 flex items-center"
              @click="
                validateAssignment(
                  'DECLINED',
                  reviewAssignment.users[currentSelectedUserIndex].userData,
                  reviewAssignment.users[currentSelectedUserIndex],
                  reviewAssignment.users[currentSelectedUserIndex]
                    .feedLibraryItemStatus
                )
              "
            >
              <img
                class="mr-2"
                src="@/assets/images/icons/org-review/cross.svg"
                alt=""
              />
              Decline
            </div>
            <div
              class="button__accept px-3 py-2 flex items-center"
              @click="
                validateAssignment(
                  'ACCEPTED',
                  reviewAssignment.users[currentSelectedUserIndex].userData,
                  reviewAssignment,
                  reviewAssignment.users[currentSelectedUserIndex]
                    .feedLibraryItemStatus
                )
              "
            >
              <img
                class="mr-2"
                src="@/assets/images/icons/org-review/tick.svg"
                alt=""
              />

              Accept
            </div>
          </div> -->

          <!-- <div
            v-else-if="
              reviewAssignment.users[currentSelectedUserIndex]
                .feedLibraryItemStatus === 'do' ||
              reviewAssignment.users[currentSelectedUserIndex]
                .feedLibraryItemStatus === 'doing'
            "
            class="flex items-center py-3 px-2"
          >
            <span>
              <img src="@/assets/images/icons/alert-circle.svg" alt="" />
            </span>
            <h5 class="ml-2 text-left" style="color: #ff6e4f !important">
              It appears that the item has not been marked as 'done'. Therefore,
              the item cannot be reviewed at this time.
            </h5>
          </div> -->
        </vs-col></vs-row
      >

      <div
        v-if="
          reviewAssignment.users &&
          reviewAssignment.users[currentSelectedUserIndex] &&
          reviewAssignment.users[currentSelectedUserIndex]
            .feedLibraryItemStatus === 'do'
        "
        class="flex items-center py-3 px-2 item-notice--do mt-2 md:mt-5"
      >
        <h5 class="ml-2 text-left">
          This item is assigned to
          {{
            reviewAssignment.users[currentSelectedUserIndex].userData.firstName
          }}
          {{
            reviewAssignment.users[currentSelectedUserIndex].userData.lastName
          }}
          by <b>admin </b>and is in <b>'Not Started'</b> state.
        </h5>
      </div>

      <div
        v-if="
          reviewAssignment.users &&
          reviewAssignment.users[currentSelectedUserIndex] &&
          reviewAssignment.users[currentSelectedUserIndex]
            .feedLibraryItemStatus === 'notInterested' &&
          !isUserValidated &&
          reviewAssignment.libraryItemValidationData &&
          reviewAssignment.libraryItemValidationData.validationType
        "
        class="flex items-center mt-2 md:mt-5 justify-between"
      >
        <div class="flex items-center py-3 px-2 item-notice--do">
          <h5 class="ml-2 text-left">
            This learning action is marked as 'Not Interested'.
          </h5>
        </div>

        <button
          class="acknowledge__button px-3 py-3"
          @click="
            validateAssignment(
              'DECLINED',
              reviewAssignment.users[currentSelectedUserIndex].userData,
              reviewAssignment.users[currentSelectedUserIndex],
              reviewAssignment.users[currentSelectedUserIndex]
                .feedLibraryItemStatus
            )
          "
        >
          Acknowledge
        </button>
      </div>

      <div
        v-if="
          reviewAssignment.users &&
          reviewAssignment.users[currentSelectedUserIndex] &&
          reviewAssignment.users[currentSelectedUserIndex]
            .feedLibraryItemStatus === 'doing'
        "
        class="flex items-center py-3 px-2 item-notice--doing mt-2 md:mt-5"
      >
        <h5 class="ml-2 text-left">
          This item is 'In Progress' state. Validation review will enable when
          user marks it as 'done'.
        </h5>
      </div>

      <div
        v-if="
          reviewAssignment.users &&
          reviewAssignment.users[currentSelectedUserIndex] &&
          reviewAssignment.users[currentSelectedUserIndex]
            .feedLibraryItemStatus === 'done' &&
          !isUserValidated &&
          reviewAssignment.libraryItemValidationData &&
          reviewAssignment.libraryItemValidationData.validationType
        "
        class="flex items-center py-3 px-2 item-notice--doing mt-2 md:mt-5"
      >
        <h5 class="ml-2 text-left">
          This learning action is marked 'Done'. A review will be queued for
          approval as soon as its validation is completed.
        </h5>
      </div>

      <div
        v-if="
          reviewAssignment.users &&
          reviewAssignment.users[currentSelectedUserIndex] &&
          reviewAssignment.users[currentSelectedUserIndex]
            .feedLibraryItemStatus === 'done' &&
          !isUserValidated &&
          !reviewAssignment.libraryItemValidationData
        "
        class="flex items-center py-3 px-2 item-notice--doing mt-2 md:mt-5"
      >
        <h5 class="ml-2 text-left">
          This learning action is marked 'Done'. Add a Validation to confirm the
          learning to release learning experience points and possible rewards.
        </h5>
      </div>

      <!-- qr scan -->
      <div
        v-if="
          reviewAssignment.users &&
          reviewAssignment.users[currentSelectedUserIndex] &&
          reviewAssignment.users[currentSelectedUserIndex]
            .feedLibraryItemStatus === 'done' &&
          reviewAssignment.libraryItemValidationData &&
          reviewAssignment.libraryItemValidationData.validationType ===
            'attendance' &&
          isUserValidated
        "
      >
        <div class="py-10 px-4 my-4 md:my-10 action__container">
          <div class="flex items-center justify-center">
            <img
              style="filter: drop-shadow(10px 10px 30px rgba(0, 16, 97, 0.2))"
              src="@/assets/images/icons/qr-code-dummy.svg"
              alt="QR Code"
            />
          </div>

          <div class="action__container__remarks">
            <div class="text-center font-bold text-xl text-black">QR Code</div>
            <div class="text-center text-lg" style="color: #787878">
              QR Code scan time: {{ scanTime }}
            </div>
          </div>
        </div>

        <div class="flex flex-col md:flex-row items-center justify-between">
          <div class="text-lg md:text-left" style="color: #787878">
            A validation is submitted on this learning. You may review and
            release the learning experience to be claimed.
          </div>
          <!-- btns  -->
          <div class="action__container__buttons mt-4 md:mt-0">
            <button
              class="decline__button px-3 py-2"
              @click="
                validateAssignment(
                  'DECLINED',
                  reviewAssignment.users[currentSelectedUserIndex].userData,
                  reviewAssignment.users[currentSelectedUserIndex],
                  reviewAssignment.users[currentSelectedUserIndex]
                    .feedLibraryItemStatus
                )
              "
            >
              <img src="@/assets/images/icons/org-review/cross.svg" />Decline
            </button>

            <button
              class="approve__button px-3 py-2"
              @click="
                validateAssignment(
                  'ACCEPTED',
                  reviewAssignment.users[currentSelectedUserIndex].userData,
                  reviewAssignment.users[currentSelectedUserIndex],
                  reviewAssignment.users[currentSelectedUserIndex]
                    .feedLibraryItemStatus
                )
              "
            >
              <img src="@/assets/images/icons/org-review/tick.svg" />Accept
            </button>
          </div>
        </div>
      </div>

      <!-- quiz -->
      <div
        v-if="
          quizResultData &&
          quizResultData.quizPercent &&
          quizResultData.numOfCorrectQuestions >= 0 &&
          quizResultData.totalNumOfQuestions &&
          isUserValidated
        "
      >
        <div class="py-10 px-4 mt-16 mb-8 action__container">
          <div class="action__container__badges">
            <img
              v-if="quizResultData.quizPercent <= 50"
              class="bad__badge"
              src="@/assets/images/icons/org-review/org-review-bad.svg"
            />

            <img
              v-else-if="
                quizResultData.quizPercent > 50 &&
                quizResultData.quizPercent <= 75
              "
              class="avg__badge"
              src="@/assets/images/icons/org-review/org-review-avg.svg"
            />

            <img
              v-else-if="quizResultData.quizPercent >= 75"
              class="good__badge"
              src="@/assets/images/icons/org-review/org-review-good.svg"
            />
          </div>

          <div class="action__container__remarks">
            <h3>Test Completed!</h3>

            <p v-if="quizResultData.quizPercent <= 50" class="bad__remark">
              That’s poor.
              {{
                reviewAssignment.users[currentSelectedUserIndex].userData
                  .firstName
              }}
              {{
                reviewAssignment.users[currentSelectedUserIndex].userData
                  .lastName
              }}
              only got <br /><span
                >{{ quizResultData.numOfCorrectQuestions }}/{{
                  quizResultData.totalNumOfQuestions
                }}</span
              >
              answers correct.
            </p>
            <p
              v-else-if="
                quizResultData.quizPercent > 50 &&
                quizResultData.quizPercent < 75
              "
              class="avg__remark"
            >
              That’s fair.
              {{
                reviewAssignment.users[currentSelectedUserIndex].userData
                  .firstName
              }}
              {{
                reviewAssignment.users[currentSelectedUserIndex].userData
                  .lastName
              }}
              got a<br /><span
                >{{ quizResultData.numOfCorrectQuestions }}/{{
                  quizResultData.totalNumOfQuestions
                }}</span
              >
              answers correct.
            </p>
            <p
              v-else-if="quizResultData.quizPercent >= 75"
              class="good__remark"
            >
              That’s great.
              {{
                reviewAssignment.users[currentSelectedUserIndex].userData
                  .firstName
              }}
              {{
                reviewAssignment.users[currentSelectedUserIndex].userData
                  .lastName
              }}
              got a<br /><span
                >{{ quizResultData.numOfCorrectQuestions }}/{{
                  quizResultData.totalNumOfQuestions
                }}</span
              >
              answers correct.
            </p>
          </div>
        </div>

        <div class="flex flex-col md:flex-row items-center justify-between">
          <div class="text-lg md:text-left" style="color: #787878">
            A validation is submitted on this learning. You may review and
            release the learning experience to be claimed.
          </div>
          <!-- btns  -->
          <div class="action__container__buttons">
            <button
              class="decline__button px-3 py-2"
              @click="
                validateAssignment(
                  'DECLINED',
                  reviewAssignment.users[currentSelectedUserIndex].userData,
                  reviewAssignment.users[currentSelectedUserIndex],
                  reviewAssignment.users[currentSelectedUserIndex]
                    .feedLibraryItemStatus
                )
              "
            >
              <img src="@/assets/images/icons/org-review/cross.svg" />Decline
            </button>

            <button
              class="approve__button px-3 py-2"
              @click="
                validateAssignment(
                  'ACCEPTED',
                  reviewAssignment.users[currentSelectedUserIndex].userData,
                  reviewAssignment.users[currentSelectedUserIndex],
                  reviewAssignment.users[currentSelectedUserIndex]
                    .feedLibraryItemStatus
                )
              "
            >
              <img src="@/assets/images/icons/org-review/tick.svg" />Accept
            </button>
          </div>
        </div>
      </div>

      <!-- upload -->
      <div
        v-if="
          reviewAssignment.users &&
          reviewAssignment.users[currentSelectedUserIndex] &&
          reviewAssignment.users[currentSelectedUserIndex]
            .feedLibraryItemStatus === 'done' &&
          reviewAssignment.libraryItemValidationData &&
          reviewAssignment.libraryItemValidationData.validationType ===
            'upload' &&
          isUserValidated
        "
      >
        <div
          class="py-10 px-4 mt-16 mb-8 action__container flex justify-center items-center"
        >
          <div class="w-1/2 h-1/2">
            <img
              class="w-full h-full object-cover"
              :src="documentUploaded"
              alt=""
            />
          </div>
        </div>

        <div class="flex flex-col md:flex-row items-center justify-between">
          <div class="text-lg md:text-left" style="color: #787878">
            A validation is submitted on this learning. You may review and
            release the learning experience to be claimed.
          </div>
          <!-- btns  -->
          <div class="action__container__buttons">
            <button
              class="decline__button px-3 py-2"
              @click="
                validateAssignment(
                  'DECLINED',
                  reviewAssignment.users[currentSelectedUserIndex].userData,
                  reviewAssignment.users[currentSelectedUserIndex],
                  reviewAssignment.users[currentSelectedUserIndex]
                    .feedLibraryItemStatus
                )
              "
            >
              <img src="@/assets/images/icons/org-review/cross.svg" />Decline
            </button>

            <button
              class="approve__button px-3 py-2"
              @click="
                validateAssignment(
                  'ACCEPTED',
                  reviewAssignment.users[currentSelectedUserIndex].userData,
                  reviewAssignment.users[currentSelectedUserIndex],
                  reviewAssignment.users[currentSelectedUserIndex]
                    .feedLibraryItemStatus
                )
              "
            >
              <img src="@/assets/images/icons/org-review/tick.svg" />Accept
            </button>
          </div>
        </div>
      </div>
    </vx-card>

    <!-- other item of current user  -->
    <div v-if="moreAssignmentLoading" id="moreItems">
      <div
        v-for="i in 5"
        :key="i"
        class="border border-blue-300 shadow rounded-lg p-4 w-full animate-pulse h-48 my-6"
        style="background: #8080805e"
      ></div>
    </div>
    <div
      v-if="moreUserAssignments.length > 0 && !assignmentLoading"
      class="mt-6"
    >
      <h4 class="text-2xl font-semibold text-black">
        Other items of
        {{
          reviewAssignment.users[currentSelectedUserIndex].userData.firstName
        }}

        {{
          reviewAssignment.users[currentSelectedUserIndex].userData &&
          reviewAssignment.users[currentSelectedUserIndex].userData.lastName
            ? reviewAssignment.users[currentSelectedUserIndex].userData.lastName
            : ""
        }}
      </h4>
      <extra-task-card
        v-for="assignment in moreUserAssignments"
        :key="assignment.itemId"
        :assignment="assignment"
        :orgId="orgId"
        class="my-4"
        v-show="
          reviewAssignment.feedLibraryItem.itemId !==
          assignment.feedLibraryItem.itemId
        "
      />
      <!-- <vx-card
        v-for="assignment in moreUserAssignments"
        :key="assignment.itemId"
        class="my-4"
        v-show="
          reviewAssignment.feedLibraryItem.itemId !==
          assignment.feedLibraryItem.itemId
        "
      >
        <vs-row class="flex-col md:flex-row"
          ><vs-col class="md:w-1/3 lg:w-1/6"
            ><div class="overflow-hidden rounded-lg assignment__img">
              <img
                class="h-full w-full object-cover"
                :src="assignment.feedLibraryItem.imageUrl"
                :alt="assignment.feedLibraryItem.title"
                @error="randomFeedImage"
              /></div></vs-col
          ><vs-col
            class="md:w-2/3 lg:w-5/6 md:pl-8 flex flex-col justify-between"
          >
            <div>
              <div class="flex items-center">
                <div
                  class="text-black text-2xl truncate grow mt-2 lg:mt-0"
                  v-if="
                    assignment.feedLibraryItem &&
                    assignment.feedLibraryItem.title
                  "
                >
                  {{ assignment.feedLibraryItem.title }}
                </div>

                <img
                  @click.once="openLink(assignment.feedLibraryItem)"
                  class="ml-3 mt-2 lg:mt-0 cursor-pointer"
                  src="@/assets/images/icons/arrow-right-circle.svg"
                  alt="right-arrow"
                />
              </div>

              <div
                class="text-lg gray-400 my-3"
                v-if="
                  assignment.feedLibraryItem &&
                  assignment.feedLibraryItem.description
                "
              >
                {{ assignment.feedLibraryItem.description }}
              </div>
            </div>

            <div v-if="assignment.libraryItemValidationData">
              <div
                class="flex items-center justify-end"
                v-if="assignment.feedLibraryItem.status === 'done'"
              >
                <div
                  class="button__decline px-3 py-2 mr-3 flex items-center"
                  @click="
                    validateAssignment(
                      'DECLINED',
                      assignment.userData,

                      assignment.feedLibraryItem
                    )
                  "
                >
                  <img
                    class="mr-2"
                    src="@/assets/images/icons/org-review/cross.svg"
                    alt=""
                  />
                  Decline
                </div>
                <div
                  class="button__accept px-3 py-2 flex items-center"
                  @click="
                    validateAssignment(
                      'ACCEPTED',
                      assignment.userData,
                      assignment.feedLibraryItem
                    )
                  "
                >
                  <img
                    class="mr-2"
                    src="@/assets/images/icons/org-review/tick.svg"
                    alt=""
                  />

                  Accept
                </div>
              </div>

              <div v-else class="flex items-center text-start py-3 px-2">
                <span>
                  <img src="@/assets/images/icons/alert-circle.svg" alt="" />
                </span>
                <h5 class="ml-2 text-left" style="color: #ff6e4f !important">
                  It appears that the item has not been marked as 'done'.
                  Therefore, the item cannot be reviewed at this time.
                </h5>
              </div>
            </div>
          </vs-col></vs-row
        >
      </vx-card> -->
    </div>

    <div
      v-if="reviewAssignmentUsers.length === 0 && !assignmentLoading"
      class="flex flex-col items-center justify-center"
    >
      <div class="md:w-1/3">
        <img
          src="@/assets/images/icons/org-review/alldone.svg"
          width="250px"
          height="250px"
        />
        <h4>Task validation is complete. All user tasks have been approved.</h4>
      </div>
    </div>

    <vs-row
      v-if="
        !assignmentLoading &&
        !moreAssignmentLoading &&
        moreUserAssignments.length === 0 &&
        reviewAssignment.users &&
        reviewAssignment.users[currentSelectedUserIndex] &&
        reviewAssignment.users[currentSelectedUserIndex].userData
      "
      class="flex justify-center mt-6"
    >
      <button
        class="loadmore-btn cursor-pointer py-3 px-6"
        @click="loadMoreItems"
      >
        Load more items for
        {{
          reviewAssignment.users[currentSelectedUserIndex].userData.firstName
        }}

        {{
          reviewAssignment.users[currentSelectedUserIndex].userData &&
          reviewAssignment.users[currentSelectedUserIndex].userData.lastName
            ? reviewAssignment.users[currentSelectedUserIndex].userData.lastName
            : ""
        }}
      </button>
    </vs-row>
  </div>
</template>

<script>
import reviewMixin from "../reviewMixin";
import ExtraTaskCard from "../components/ExtraTaskCard.vue";
export default {
  mixins: [reviewMixin],
  components: {
    ExtraTaskCard,
  },
  data() {
    return {
      reviewAssignment: {},
      currentSelectedUserIndex: null,
      routeToLink: false,
      reviewAssignmentUsers: [],
      moreUserAssignments: [],
      moreAssignmentLoading: false,
      userName: "",
      userProfilePic: "",
      quizResultData: {},
      xp: 0,
      gold: 0,
      isUserItemsView: false,
      scanTime: "",
      isUserValidated: false,
      documentUploaded: "",
    };
  },
  computed: {
    loggedUserData() {
      return this.$store.state.users.data;
    },
  },
  watch: {
    orgAssignments: {
      handler(newVal) {
        if (Object.keys(newVal).length > 0) {
          this.reviewAssignment = newVal.find((obj) => {
            return obj.itemId === this.$route.params.itemId;
          });

          this.reviewAssignmentUsers = this.reviewAssignment.users;
          this.getQuizResult();

          if (
            this.reviewAssignment &&
            this.reviewAssignment.users &&
            this.reviewAssignment.users[this.currentSelectedUserIndex] &&
            this.reviewAssignment.users[this.currentSelectedUserIndex].userData
          ) {
            this.getToken(
              this.reviewAssignment.users[this.currentSelectedUserIndex]
                .userData.aggregatedWallet
            );
          }
          this.assignmentLoading = false;
        }
      },
      deep: true,
      immediate: true,
    },
    assignmentLoading(newVal) {
      if (!newVal) {
        if (Object.keys(this.orgAssignments).length > 0) {
          this.reviewAssignment = this.orgAssignments.find((obj) => {
            return obj.itemId === this.$route.params.itemId;
          });
          this.assignmentLoading = false;
        } else {
          this.assignmentLoading = false;
          this.$router.push({
            name: "org-reviews",
          });
        }
      }
    },
    currentSelectedUserIndex(newVal) {
      this.isUserValidated = false;
      this.moreUserAssignments = [];
      this.getQuizResult();
      this.getQrScanTime();
      this.getDocument();

      if (
        this.reviewAssignment &&
        this.reviewAssignment.users &&
        this.reviewAssignment.users[newVal] &&
        this.reviewAssignment.users[newVal].userData
      ) {
        this.getToken(
          this.reviewAssignment.users[newVal].userData.aggregatedWallet
        );
      }
    },
    reviewAssignment: {
      handler() {
        this.getQuizResult();
        this.getQrScanTime();
        this.getDocument();
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
      this.isUserItemsView = true;
    if (this.$route.query && this.$route.query.uid && this.$route.query.user) {
      this.currentSelectedUserIndex = this.$route.query.user;
    } else {
      this.currentSelectedUserIndex = 0;
    }

    if (
      this.reviewAssignment &&
      this.reviewAssignment.libraryItemValidationData &&
      this.reviewAssignment.libraryItemValidationData.validationType &&
      this.reviewAssignment.libraryItemValidationData.validationType === "quiz"
    ) {
      this.getQuizResult();
    }

    if (
      this.reviewAssignment &&
      this.reviewAssignment.libraryItemValidationData &&
      this.reviewAssignment.libraryItemValidationData.validationType &&
      this.reviewAssignment.libraryItemValidationData.validationType ===
        "attendance"
    ) {
      this.getQrScanTime();
    }

    if (
      this.reviewAssignment &&
      this.reviewAssignment.libraryItemValidationData &&
      this.reviewAssignment.libraryItemValidationData.validationType &&
      this.reviewAssignment.libraryItemValidationData.validationType ===
        "upload"
    ) {
      this.getUpload();
    }
  },
  methods: {
    randomFeedImage(e) {
      let i = 15; // i = number of given random images
      return (e.target.src = require(`@/assets/images/user-dashboard/blank-feed/${[
        Math.floor(Math.random() * i),
      ]}.png`));
    },
    setActiveCircle(index) {
      this.currentSelectedUserIndex = index;
    },
    handleNext() {
      if (
        this.reviewAssignment &&
        this.reviewAssignmentUsers &&
        this.currentSelectedUserIndex < this.reviewAssignmentUsers.length - 1
      ) {
        this.currentSelectedUserIndex++;
      }
    },
    handlePrevious() {
      if (this.currentSelectedUserIndex > 0) {
        this.currentSelectedUserIndex--;
      }
    },
    openLink(item) {
      let link = `https://library.getboarded.com/redirect-page?itemId=${
        item.itemId
      }&type=${item.type || item.itemType}&gbuid=${this.userData._id}&gborgid=${
        this.orgId
      }&redirectsourceid=ORG_REVIEW`;
      this.routeToLink = true;
      if (link && this.routeToLink) {
        window.open(link, "_blank");
        this.routeToLink = false;
      }
    },
    validateAssignment(status, currentUser, item, completionStatus) {
      event.stopPropagation();
      if (completionStatus === "do" || completionStatus === "doing") {
        this.$vs.notify({
          color: "warning",
          text: "It appears that the item has not been marked as 'done' by the user yet. Therefore, the item cannot be reviewed at this time.",
        });
        this.handleNext();
      } else {
        this.routeToLink = false;
        const payload = {
          libraryItemIds: [item.itemId || item.feedLibraryItem.itemId],
          reviewStatus: status,
          gtbrddOrganizationId: this.orgId,
          gtbrddUserId: currentUser._id,
          xpValue: this.reviewAssignment.libraryItemValidationData.xpValue,
        };

        this.$store
          .dispatch("alex/reviewAssignment", payload)
          .then((res) => {
            if (res) {
              this.reviewAssignmentUsers = this.reviewAssignment.users.splice(
                this.currentSelectedUserIndex,
                1
              );
              if (
                this.currentSelectedUserIndex >=
                this.reviewAssignmentUsers.length
              ) {
                this.currentSelectedUserIndex = 0;
              }
            }
          })
          .catch((err) => {
            //  console.log(err);
          });
      }
    },
    loadMoreItems() {
      const loadElement = setInterval(function () {
        let elementPosition = document
          .getElementById("moreItems")
          .getBoundingClientRect().top;
        let headerOffset = 150;
        let offsetPosition =
          elementPosition + window.pageYOffset - headerOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }, 100);
      setTimeout(() => {
        clearInterval(loadElement);
      }, 1000);
      this.moreAssignmentLoading = true;
      const payload = {
        orgId: this.orgData._id,
        userId:
          this.reviewAssignment.users[this.currentSelectedUserIndex].userData
            ._id,
      };
      this.$store
        .dispatch("alex/getUserItems", payload)
        .then((res) => {
          if (res && res.data.length > 0) {
            this.moreUserAssignments = res.data;
          }
        })
        .catch((err) => {
          //console.log(err);
        })
        .finally(() => {
          this.moreAssignmentLoading = false;
        });
    },
    getAssignedUser(id) {
      this.$store
        .dispatch("users/getAssignedUser", id)
        .then((res) => {
          this.userProfilePic = res.profilePictureUrl
            ? res.profilePictureUrl
            : "";
          if (
            res.firstName === this.loggedUserData.firstName &&
            res.lastName === this.loggedUserData.lastName
          ) {
            this.userName = "you";
          } else {
            this.userName = `${res.firstName} ${
              res.lastName ? res.lastName : ""
            }`;
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    getQuizResult() {
      if (
        this.reviewAssignment &&
        this.reviewAssignment.libraryItemValidationData &&
        this.reviewAssignment.libraryItemValidationData.validationType ===
          "quiz"
      ) {
        const payload = {
          orgId: this.orgId,
          userId:
            this.reviewAssignmentUsers &&
            this.reviewAssignmentUsers[this.currentSelectedUserIndex] &&
            this.reviewAssignmentUsers[this.currentSelectedUserIndex].userData
              ? this.reviewAssignmentUsers[this.currentSelectedUserIndex]
                  .userData._id
              : "",
          itemId: this.$route.params.itemId,
        };
        this.$store
          .dispatch("organization/fetchQuizResult", payload)
          .then((res) => {
            if (res && res.data) {
              if (res.data.quizComplete) {
                const quizPercent = (
                  (res.data.numOfCorrectQuestions /
                    res.data.totalNumOfQuestions) *
                  100
                ).toFixed(2);

                this.isUserValidated = true;

                this.quizResultData = {
                  quizPercent: quizPercent,
                  numOfCorrectQuestions: res.data.numOfCorrectQuestions,
                  totalNumOfQuestions: res.data.totalNumOfQuestions,
                };
              }
            }
          })
          .catch((err) => {
            // console.log(err);
          });
      }
    },
    getToken(tokens) {
      if (tokens && tokens.length > 0) {
        for (let i = 0; i < tokens.length; i++) {
          if (tokens[i].tokenKey === 0) {
            this.xp = tokens[i].tokenValueSum;
          } else if (tokens[i].tokenKey === 2) {
            this.gold = tokens[i].tokenValueSum;
          }
        }
      }
    },
    getQrScanTime() {
      if (
        this.reviewAssignment &&
        this.reviewAssignment.libraryItemValidationData &&
        this.reviewAssignment.libraryItemValidationData.validationType ===
          "attendance"
      ) {
        this.scanTime = "";
        this.$store
          .dispatch("users/getAttendance", {
            organizationId: this.orgId,
            feedItemId: this.reviewAssignment.itemId,
            userId:
              this.reviewAssignmentUsers &&
              this.reviewAssignmentUsers[this.currentSelectedUserIndex] &&
              this.reviewAssignmentUsers[this.currentSelectedUserIndex].userData
                ? this.reviewAssignmentUsers[this.currentSelectedUserIndex]
                    .userData._id
                : "",
          })
          .then((res) => {
            if (res && res.data && res.data.validated_at) {
              const timestamp = new Date(res.data.validated_at);
              const userTimeZone =
                Intl.DateTimeFormat().resolvedOptions().timeZone;

              const options = {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                timeZone: userTimeZone,
              };
              const formattedDate = timestamp.toLocaleDateString(
                "en-US",
                options
              );
              this.scanTime = formattedDate;
              this.isUserValidated = true;
            }
          })
          .catch(() => {});
      }
    },
    getDocument() {
      if (
        this.reviewAssignment &&
        this.reviewAssignment.libraryItemValidationData &&
        this.reviewAssignment.libraryItemValidationData.validationType ===
          "upload"
      ) {
        const payload = {
          orgId: this.orgId,
          userId:
            this.reviewAssignmentUsers &&
            this.reviewAssignmentUsers[this.currentSelectedUserIndex] &&
            this.reviewAssignmentUsers[this.currentSelectedUserIndex].userData
              ? this.reviewAssignmentUsers[this.currentSelectedUserIndex]
                  .userData._id
              : "",
          itemId: this.$route.params.itemId,
        };
        this.$store
          .dispatch("organization/fetchUploadedDocument", payload)
          .then((res) => {
            if (res && res.data && res.data.s3FilePath) {
              this.isUserValidated = true;
              this.documentUploaded = res.data.s3FilePath;
            }
          })
          .catch((err) => {
            // console.log(err);
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../reviewBase.scss";

.loadmore-btn {
  border-radius: 10px;
  color: #212020;
  font-weight: 600;
  font-size: 1.25em;
  background-color: #cbd5e0ae !important;
  border: none;
  &--light {
    background-color: #cbd5e077 !important;
  }
}

.item-notice {
  &--do {
    background: #f044380a;
    border: 2px solid #f044381a;
    border-radius: 0.5rem;
    h5 {
      color: #f04438 !important;
    }
  }
  &--doing {
    background: #f293000f;
    border: 2px solid #f293001a;
    border-radius: 0.5rem;
    h5 {
      color: #f29300 !important;
    }
  }
}

.action__container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  border: 2px solid #eaecf0;
  border-radius: 0.75rem;
  gap: 2rem;

  &__badges {
    width: fit-content;
    place-self: center;

    img {
      width: 8rem;
      height: auto;
    }

    .good__badge {
      width: 10rem;
      height: auto;
    }
  }

  &__remarks {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: fit-content;
    place-self: center;

    h3 {
      color: #000;
      text-align: center;
      font-size: 1.25rem;
      font-weight: 700;
    }

    p {
      color: #787878;
      text-align: center;
      font-size: 1rem;
      font-weight: 400;

      span {
        font-size: 1rem;
        font-weight: 700;
      }
    }

    .bad__remark {
      span {
        color: #fb2e56;
      }
    }

    .avg__remark {
      span {
        color: #f36f0f;
      }
    }

    .good__remark {
      span {
        color: #12b76a;
      }
    }
  }

  &__buttons {
    width: fit-content;
    place-self: center;
    gap: 2rem;
    display: flex;
    flex-direction: row;

    button {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 1.25rem;
      gap: 0.8rem;
      color: #fff;
      text-align: center;
      font-weight: 600;

      img {
        height: auto;
      }
    }

    .decline__button {
      background-color: #fb2e56;
      border: none;
      cursor: pointer;
    }

    .approve__button {
      background-color: #12b76a;
      border: none;
      cursor: pointer;
    }
  }
}

.acknowledge__button {
  background-color: #d0d5dd;
  color: #667085;
  border: none;
  cursor: pointer;
  font-size: 1.2rem;
}
</style>
